import { gql } from '@apollo/client'

export interface TowingOrderPaymentLinkMutationVariables
  extends Readonly<{ input: { towingOrderId: number } }> {}

export const RESEND_TOWING_ORDER_PAYMENT_LINK = gql`
  mutation ResendTowingOrderPaymentLink($input: TowingOrderPaymentLinkInput!) {
    resendTowingOrderPaymentLink(input: $input) {
      __typename
      ... on ResendTowingOrderPaymentLinkSuccess {
        success
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on ResourceNotFoundError {
        error {
          code
          message
        }
      }
      ... on InvalidStateError {
        error {
          code
          message
        }
      }
    }
  }
`

export const CANCEL_TOWING_ORDER_PAYMENT_LINK = gql`
  mutation CancelTowingOrderPaymentLink($input: TowingOrderPaymentLinkInput!) {
    cancelTowingOrderPaymentLink(input: $input) {
      __typename
      ... on CancelTowingOrderPaymentLinkSuccess {
        success
      }
      ... on UnauthorizedError {
        error {
          code
          message
        }
      }
      ... on ResourceNotFoundError {
        error {
          code
          message
        }
      }
      ... on InvalidStateError {
        error {
          code
          message
        }
      }
    }
  }
`
